import { Box } from '@mui/material';
import Image from 'next/image';

type MapMarkerProps = {
    lat: number;
    lng: number;
    zoom: number;
    clusterId?: number;
    organisationId?: number;
    // Exposed for the google-maps-react-markers overlay; not used directly here
    zIndex?: number;
    onClick: (lat: number, lng: number, organisationId?: number, clusterId?: number) => void;
};

export function MapMarker({ lat, lng, zoom, organisationId, clusterId, onClick }: MapMarkerProps) {
    const isCluster = Boolean(clusterId);
    const scale = isCluster ? 15 : 8;
    const size = zoom * scale;
    const mapImagesFolder = '/icons/map/';
    const image = `${mapImagesFolder}${isCluster ? 'hearts-150x150.png' : 'heart-marker-80x80.png'}`;
    const halfSize = size / 2;

    return (
        <Box
            onClick={() => onClick(lat, lng, organisationId, clusterId)}
            sx={{
                '& img': {
                    cursor: 'pointer',
                    position: 'relative',
                    left: -halfSize,
                    top: -halfSize,
                },
            }}
        >
            <Image src={image} alt="" width={size} height={size} />
        </Box>
    );
}
